
<template>
<section>
  <chc-modal ref="newTierModal" title="New Tiered Proceeds Rate">
      <div slot="body">
        <charity-proceeds-rate-tiers v-on:refresh="refresh"
                        v-on:close="addProceedsTierHide"
        ></charity-proceeds-rate-tiers>
      </div>
    </chc-modal>
    <chc-modal ref="uploadAgreementModal" title="Upload Agreement">
    <div slot="body">
      <charity-upload-agreement :charityId="charityId"
                        :uploadOnSubmit="charityId ? true : false"
                        v-on:addFile="onAddFile"
                        v-on:refresh="refreshAgreement"
                        v-on:close="uploadAgreementHide"
                        ref="uploadAgreement">
      </charity-upload-agreement>
    </div>
  </chc-modal>
  <div class="tabbed-content">
    <div class="columns">
      <div class="col">
        <chc-input v-model="data.name" label="Charity Name" :required="true" :error="errors.name"></chc-input>
        <chc-input v-model="data.address_street" label="Mailing Address" :error="errors.address_street"></chc-input>
        <chc-input v-model="data.address_city" label="City" :error="errors.address_city"></chc-input>
        <chc-input v-model="data.address_state" label="State" format="combo"
                   :autoCompleteValues="$store.state.constants.us_states_list" :error="errors.address_state"></chc-input>
        <chc-input v-model="data.address_zip" label="Zip" format="zip" :error="errors.address_zip"></chc-input>
      </div>
      <div class="col">
        <chc-input v-model="data.fax" label="Charity Fax" :error="errors.fax"></chc-input>
        <chc-input v-model="data.website" label="Website" :error="errors.website"></chc-input>
        <chc-input v-model="data.donate_phone1" label="Donate Phone 1" :error="errors.donate_phone1"></chc-input>
        <chc-input v-model="data.donate_phone2" label="Donate Phone 2" :error="errors.donate_phone2"></chc-input>
        <chc-input v-model="data.tax_id" label="Federal Tax ID" :error="errors.tax_id"></chc-input>
      </div>
    </div>
    <div class="columns" v-for="(key, index) in contactTypes" v-bind:key="key">
      <div class="col">
        <h2>{{key}} Contact</h2>
        <chc-input v-model="data.contacts[index].first_name" :label="key +  ' Contact First Name'" :error="errors['contacts.' + index + '.first_name']"></chc-input>
        <chc-input v-model="data.contacts[index].last_name" :label="key +  ' Contact Last Name'" :error="errors['contacts.' + index + '.last_name']"></chc-input>
        <chc-input v-model="data.contacts[index].title" :label="key +  ' Contact Title'" :error="errors['contacts.' + index + '.title']"></chc-input>
        <chc-input v-model="data.contacts[index].email" :label="key +  ' Contact Email Address'" :error="errors['contacts.' + index + '.email']"></chc-input>
        <chc-input v-model="data.contacts[index].phone" :label="key +  ' Contact Phone Number'" :error="errors['contacts.' + index + '.phone']"></chc-input>
      </div>
      <div class="col" v-if="data.contacts[index].id != null">
        <dl class="field user-management">
          <dt class="data-label">{{key}} Contact User</dt>
          <dd class="data-content" v-if="contactEdited(index)">Save changes before managing contacts.</dd>
          <dd class="data-content" v-else-if="data.contacts[index].user == null && !canCreateUser(index)">First Name, Last Name, and Email is required to create a user from a contact.</dd>
          <a v-else-if="data.contacts[index].user == null && canCreateUser(index)" @click="createUser(data.contacts[index])">Create User</a>
          <dd class="data-content" v-else-if="data.contacts[index].user && data.contacts[index].user.charity_id != charityId">
            User Registered {{data.contacts[index].user.charityName}}
          </dd>
          <dd class="data-content" v-else-if="data.contacts[index].user.deleted_at != null">User Deactivated <a @click="reactivateUser(data.contacts[index].user.id)">Reactivate</a></dd>
          <a v-else-if="data.contacts[index].user && !data.contacts[index].user.verified" @click="resendRegistration(data.contacts[index].user.id)">Resend Registration</a>
          <dd class="data-content" v-else-if="data.contacts[index].user.deleted_at == null">User Registered <a @click="deactivateUser(data.contacts[index].user.id)">Deactivate</a></dd>
          <dd v-show="data.contacts[index].resendSuccess !== undefined" :class="{'success-message' : data.contacts[index].resendSucess, 'error-message' : !data.contacts[index].resendSucess}">
            {{data.contacts[index].resendSuccess ? 'Registration Resent' : 'Unable to resend registration'}}
          </dd>
        </dl>
      </div>
    </div>
    <hr>
    <div class="columns">
      <div class="col">
        <div class="field">
          <chc-input v-model="data.status" label="Status" format="combo"
                   :autoCompleteValues="$store.state.charity.charityStatus" :error="errors.status"></chc-input>
        </div>
        <div class="field">
          <chc-checkbox v-model="data['501c_on_file']" label="501c On File"></chc-checkbox>
          <chc-checkbox v-model="data.featured" label="Featured"></chc-checkbox>
        </div>
        <a v-if="!data.agreement_document && !data.file" @click="uploadAgreementShow"><span class="icon fas fa-upload" aria-hidden="true"></span> Upload Agreement Document</a>
        <dl v-if="data.file">
          <dt class="data-label">Agreement Document</dt>
          <div class="col">
            <dd class="data-content">{{ data.file.name }}</dd>
          </div>
        </dl>
        <dl v-if="data.agreement_document">
          <dt class="data-label">Agreement Document</dt>
          <div class="col">
            <dd class="data-content">{{ data.agreement_document_name }}</dd>
          </div>
          <div class="col">
            <a @click="downloadAgreement">Download</a>
          </div>
      </dl>
        <a v-if="data.agreement_document || data.file" @click="uploadAgreementShow"><span class="icon fas fa-upload" aria-hidden="true"></span> Upload New Agreement Document</a>
      </div>
      <div class="col">
        <div class="field">
          <chc-input v-model="data.date_affiliated" label="Date Affiliated" type="date" :error="errors.date_affiliated"></chc-input>
        </div>
        <div class="field">
          <chc-input v-model="data.proceeds_rate_id" label="Proceeds Rate ID" format="combo"
                   :autoCompleteValues="tieredAutocomplete" :error="errors.proceeds_rate_id" ref="proceedsRate"></chc-input>
        </div>
        <chc-input v-if="data.proceeds_rate_id == 'fixed'" v-model="data.payout_percentage_cents" label="Payout %" format="percent" :error="errors.payout_percentage_cents"></chc-input>
        <div class="field" v-if="data.proceeds_rate_id && isFinite(data.proceeds_rate_id.value)">
          <!-- If a tiered rate is selected, show tiers -->
          <table class="simple-table">
            <!-- for each tier -->
            <tr v-for="(rate,index) in JSON.parse(data.proceeds_rate_id.rates)" :key="index">
              <td v-if="rate.top != 'Unlimited'">{{ rate.bottom }} - {{rate.top }} Vehicles per month</td>
              <td v-if="rate.top == 'Unlimited'">{{ rate.bottom }}+ Vehicles per month</td>
              <td>{{ formatPercent(rate.rate) }} Payout</td>
            </tr>
          </table>
          <!-- end if -->
        </div>
        <div class="field">
          <a @click="addProceedsTier()">+ Add New Tiered Proceeds Rate</a>
        </div>
        <chc-input v-model="data.chc_proceeds_min_cents" label="CHC Proceeds Min" format="currency" :error="errors.chc_proceeds_min_cents"></chc-input>
        <chc-input v-model="data.processing_fee_cents" label="Processing Fee" format="currency" :error="errors.processing_fee_cents"></chc-input>
        <dl>
          <dt class="data-label">Negative Balance</dt>
          <div class="radio-option" v-for="(key, index) in $store.state.charity.negativeBalance" v-bind:key="index">
            <input type="radio" name="negative_balance" :id="key.value" :value="key.value" v-model="data.negative_balance">
            <label class="inline-label" :for="key.value">{{ key.label }}</label>
          </div>
          <div v-if="errors.negative_balance" class="error-message">
            <span v-for="(e, index) in errors.negative_balance" :key="index">
              {{ e }}
            </span>
          </div>
        </dl>
      </div>
    </div>
    <div class="columns">
      <div class="col">
        <slot name='saveButton'></slot>
      </div>
    </div>
  </div>
</section>
</template>

<script>
import store from '@/store'
import helpers from '@/helpers'
import CharityProceedsRateTiers from '@/components/Charity/CharityProceedsRateTiers'
import CharityUploadAgreement from '@/components/Charity/CharityUploadAgreement'

export default {
  name: 'CharityInformation',
  components: {
    CharityProceedsRateTiers,
    CharityUploadAgreement,
  },
  data () {
    return {
      hasErrors: false,
      errors: {},
      tieredAutocomplete: this.$store.state.charity.proceedsRateId,
      hasFile: false,

      contactTypes: {
        main: 'Main',
        marketing: 'Marketing',
        accounting: 'Accounting',
        charity_agreement_signator: 'Charity Agreement Signator'
      },
      resendSuccess: null,
    }
  },
  props: ['data', 'charityId', 'savedContacts'],
  methods: {
    contactEdited (index) {
      return this.data.contacts[index].first_name !== this.savedContacts[index].first_name ||
          this.data.contacts[index].last_name !== this.savedContacts[index].last_name ||
          this.data.contacts[index].email !== this.savedContacts[index].email
    },
    canCreateUser (index) {
      return (this.data.contacts[index].first_name !== null && this.data.contacts[index].first_name !== '') &&
          (this.data.contacts[index].first_name !== null && this.data.contacts[index].first_name !== '') &&
          (this.data.contacts[index].last_name !== null && this.data.contacts[index].last_name !== '')
    },
    createUser (contact) {
      store.functions.users.createUser({
        first_name: contact.first_name,
        last_name: contact.last_name,
        email: contact.email,
        user_role: 'charity',
        charity_id: this.charityId
      }, err => {
        console.log(err)
      }).then(response => {
        this.$emit('refresh')
      })
    },
    resendRegistration (id) {
      var self = this
      store.functions.users.resendRegistration(id,
        (errors) => {
          this.resendSuccess = false
          this.isLoading = false
        }).then(() => {
        this.$toast.success('Registration resent!')
        this.resendSuccess = true
        let indices = Object.keys(self.data.contacts)
        for (var i = indices.length - 1; i >= 0; i--) {
          if (self.data.contacts[indices[i]].user && self.data.contacts[indices[i]].user.id === id) {
            self.data.contacts[indices[i]].resendSuccess = true
          }
        }
        this.isLoading = false
      }).catch((error) => {
        console.log(error)
        this.$toast.error('Failed to resend registration...')
        this.resendSuccess = false
        let indices = Object.keys(self.data.contacts)
        for (var i = indices.length - 1; i >= 0; i--) {
          if (self.data.contacts[indices[i]].user && self.data.contacts[indices[i]].user.id === id) {
            self.data.contacts[indices[i]].resendSuccess = false
          }
        }
        this.isLoading = false
      })
    },
    deactivateUser (id) {
      store.functions.users.deactivateUser(
        id,
        (errors) => {
          this.errors = errors
          this.hasErrors = true
        })
        .then(() => {
          this.$emit('refresh')
        })
    },
    reactivateUser (id, contact) {
      store.functions.users.reactivateUser(
        id,
        {},
        (errors) => {
          this.errors = errors
          this.hasErrors = true
        })
        .then(() => {
          this.$emit('refresh')
        })
    },
    uploadAgreementShow () {
      if (this.$refs.uploadAgreementModal) this.$refs.uploadAgreementModal.show()
      else this.$emit('showUploadAgreement')
    },
    uploadAgreementHide () {
      this.$refs.uploadAgreementModal.hide()
    },
    refreshAgreement () {
      this.$emit('refresh')
      this.uploadAgreementHide()
    },
    onAddFile (file) {
      this.$emit('addFile', file)
      this.uploadAgreementHide()
    },
    uploadAgreement (charityId) {
      if (this.hasFile) this.$refs.uploadAgreement.upload(charityId)
    },
    downloadAgreement () {
      store.functions.charity.downloadAgreement(this.charityId, (error) => {
        console.log(error)
      }).then((response) => {
        helpers.openAsDownload(response.data, this.data.agreement_document_name)
      })
    },
    addProceedsTier () {
      this.$refs.newTierModal.show()
    },
    addProceedsTierHide () {
      this.$refs.newTierModal.hide()
    },
    refresh (tier = null) {
      Promise.all([
        store.dispatch('syncConstants'),
        store.dispatch('syncSummary'),
      ]).catch(() => {
      }).then(() => {
        this.tieredAutocomplete = this.$store.state.charity.proceedsRateId
        this.$nextTick(() => { this.data.proceeds_rate_id = tier.tier.id })
      })
    },
    formatPercent (value) {
      return (+value / 100).toFixed(2) + '%'
    },
  },
  computed: {
  },
}
</script>

<style scoped lang="scss">
.data-content {
  max-width: 400px;
  overflow: scroll;
}
.user-management .error-message {
  margin-left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Charity/CharityInformation.vue